import { render, staticRenderFns } from "./ModalAuthorize.vue?vue&type=template&id=a30530e6&"
import script from "./ModalAuthorize.vue?vue&type=script&lang=js&"
export * from "./ModalAuthorize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports